import React from 'react';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { FormField } from 'core/components/form';
import { sweepAccountFieldPermissions } from 'core/helpers/sweep-account';
import { CreditCardField } from 'offer/components/checkout/components/billing-information/credit-card-field';
import { ACHFields } from 'common/components/payment/ach-fields';

/**
 * Shared payment-method collection for the sweep-account setup and add-method forms.
 * Renders Grid items for an ancestor Grid container (the CollapsibleSection body).
 * Reuses the checkout Basis Theory elements so card/bank details are tokenized client
 * side and never touch our servers. Requires an ancestor BasisTheory + element-refs
 * provider and a Formik context carrying `paymentMethodType`.
 */
const PaymentMethodFields = () => {
  const { values } = useFormikContext();

  return (
    <>
      <FormField
        permissions={sweepAccountFieldPermissions}
        xs={12}
        type="select"
        name="paymentMethodType"
        mode="light"
        label="Payment Method Type"
        options={[
          { id: 'card', value: 'Credit / debit card' },
          { id: 'us_bank_account', value: 'Bank account (ACH)' }
        ]}
        fast={false}
        data-cy="sweep-payment-method-type"
      />
      <Grid item xs={12}>
        {values.paymentMethodType === 'us_bank_account' ? <ACHFields mode="light" /> : <CreditCardField />}
      </Grid>
    </>
  );
};

export default PaymentMethodFields;
